import { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Col, Row } from 'react-styled-flexboxgrid';

import { INPUT_TYPES } from '@savgroup-front-common/constants';

import { FormGroup, Input } from '../../../../atoms/Form';
import { PercentageRubric } from '../../Datatable.types';
import { DatatableFiltersModel } from '../DatatableFiltersModel';

import { useFilterPercentage } from './FiltersPercentage.hooks';
import FiltersPercentageTag from './FiltersPercentageTag';

const FiltersPercentage: FunctionComponent<{
  filter: PercentageRubric;
  onChange: (selectedFilter: PercentageRubric) => void;
  dataTestId?: string;
}> = ({ filter, onChange, dataTestId }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const {
    defaultMin,
    defaultMax,
    min,
    max,
    onChangeRangeMin,
    onChangeRangeMax,
  } = useFilterPercentage({ filter, onChange });

  return (
    <DatatableFiltersModel
      title={filter.label}
      tag={
        <FiltersPercentageTag
          min={min}
          max={max}
          defaultMin={defaultMin}
          defaultMax={defaultMax}
          dataTestId={`${dataTestId}_filtersPercentage_tag_${filter.name}`}
        />
      }
      filterContent={
        <FormGroup>
          <Row>
            <Col xs={6}>
              <Controller
                name={`filterStartRangeNumeric_${filter.name}`}
                control={control}
                render={({ field }) => (
                  <Input
                    ref={field.ref}
                    value={min === undefined ? '' : min}
                    name={field.name}
                    placeholder={`${defaultMin}`}
                    max={max !== undefined ? max : defaultMax}
                    min={defaultMin}
                    type={INPUT_TYPES.NUMBER}
                    suffix="%"
                    onChange={(event) => {
                      const newValue = parseFloat(event.target.value);

                      field.onChange(
                        Number.isNaN(newValue) ? undefined : newValue,
                      );
                      onChangeRangeMin();
                    }}
                    onBlur={(event) => {
                      const newValue = parseFloat(event.target.value);

                      field.onChange(
                        Number.isNaN(newValue) ? undefined : newValue,
                      );
                    }}
                    dataTestId={`${dataTestId}_filterStartRangeNumeric_${filter.name}`}
                  />
                )}
              />
            </Col>
            <Col xs={6}>
              <Controller
                name={`filterEndRangeNumeric_${filter.name}`}
                control={control}
                render={({ field }) => (
                  <Input
                    ref={field.ref}
                    value={max === undefined ? '' : max}
                    name={field.name}
                    placeholder={`${defaultMax}`}
                    max={defaultMax}
                    min={min !== undefined ? min : defaultMin}
                    type={INPUT_TYPES.NUMBER}
                    suffix="%"
                    errors={errors}
                    onChange={(event) => {
                      const newValue = parseFloat(event.target.value);

                      field.onChange(
                        Number.isNaN(newValue) ? undefined : newValue,
                      );
                      onChangeRangeMax();
                    }}
                    onBlur={(event) => {
                      const newValue = parseFloat(event.target.value);

                      field.onChange(
                        Number.isNaN(newValue) ? undefined : newValue,
                      );
                    }}
                    dataTestId={`${dataTestId}_filterEndRangeNumeric_${filter.name}`}
                  />
                )}
              />
            </Col>
          </Row>
        </FormGroup>
      }
    />
  );
};

FiltersPercentage.displayName = 'FiltersPercentage';
export default FiltersPercentage;
